import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getFormatImages } from '@src/utils/formatImage';
import PicOne from './PicOne';
import PicTwo from './PicTwo';
import PicThree from './PicThree';
import PicFourMore from './PicFourMore';
import { type Post } from '@src/services/interface';

type PicsProps = {
    content: {
        list?: Post['images'];
        isComment?: boolean;
    };
};

const Pics: React.FC<PicsProps> = ({ content }) => {
    const { list = [], isComment } = content;

    const images = getFormatImages(isComment ? list.slice(0, 1) : list, { isComment });

    switch (images.length) {
        case 0:
            return null;
        case 1:
            return <PicOne content={{ images, isComment }} />;
        case 2:
            return <PicTwo content={{ images }} />;
        case 3:
            return <PicThree content={{ images }} />;
        default:
            return <PicFourMore content={{ images }} />;
    }
};

export default errorBoundary(Pics);
